export default __webpack_public_path__ + "static/Donate_rain-371d3ac3fd68d5de094ce60f9d4b3589.png";